import { createRoute, useEntityUrl } from 'framework/routing';
import { RECRUITMENT_POOL_PATH } from './constants';

export const useRecruitmentPoolRoute = () => {
  const route = createRoute({ listRoute: RECRUITMENT_POOL_PATH });
  return {
    ...route,
    sourcingRoute: `${route.singleEntityRoute}/sourcing`,
  };
};

export const useRecruitmentPoolUrl = () => {
  const url = useEntityUrl({ baseLink: RECRUITMENT_POOL_PATH });
  return {
    ...url,
    getSourcingUrl: (id: string) => `${url.getSingleEntityUrl(id)}/sourcing`,
  };
};
